import {
  Stack
} from '@chakra-ui/react'
import type { DetailedUser, EditUser } from 'BrokerTsLib/src/dtos'
import { useGetRoles, useGetUserTypes } from 'BrokerTsLib/src/hooks/useUser'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import type { Ref } from 'react'
import { forwardRef } from 'react'

import { FormGroup } from '@/components/FormGroup'
import type { FormSectionProps } from '@/containers/forms/FormSection'
import { FormSection } from '@/containers/forms/FormSection'
import { useAuth } from '@/context/AuthContext'
import { SelectFormControl, SwitchFormControl } from 'BrokerTsLib/src/components'

export const UserAccessFormSection = forwardRef(function UserAccessFormSection(
  {
    user,
    isCreate,
    ...rest
  }: { user: DetailedUser; isCreate: boolean } & FormSectionProps,
  ref: Ref<HTMLDivElement>,
) {
  const { control } = useFormContext<EditUser>()

  const { data: userTypesData, isLoading: isLoadingTypes } = useGetUserTypes()
  const { data: rolesData, isLoading: isLoadingRoles } = useGetRoles(user.userId)

  const { user: loggedUser } = useAuth()

  return (
    <FormSection ref={ref} sectionTitle="Nastavení přístupu" {...rest}>
      <Stack>
        <FormGroup sx={{ gap: 4, alignItems: 'flex-start' }}>
          <SelectFormControl
            name='roles.0.role'
            control={control}
            label='Role'
            options={rolesData?.map(({ role, roleName }) => ({
              value: role,
              label: roleName,
            })) ?? []}
            unselectedText='Vyberte roli'
            isLoading={isLoadingRoles}
            formControlVariant="fullWidth"
            rules={{ required: 'Vyberte roli' }}
          />

          <SelectFormControl
            name='userTypeId'
            control={control}
            label='Typ uživatele'
            options={userTypesData?.map(({ id, itemName }) => ({
              value: id,
              label: itemName,
            })) ?? []}
            unselectedText='Vyberte typ uživatele'
            isLoading={isLoadingTypes}
            formControlVariant="fullWidth"
            rules={{ required: 'Vyberte typ uživatele' }}
          />

          {loggedUser?.allowAdAuthentication && (
            <SwitchFormControl
              label="AD&nbsp;autentizace"
              name='properties.adAuthentication'
              control={control}
              mt={10}
            /> 
          )}

          {!isCreate && (
            <SwitchFormControl
              label="Aktivní"
              name='valid'
              control={control}
              mt={10}
            />
          )}
        </FormGroup>
      </Stack>
    </FormSection>
  )
})
